import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MessageCircle } from 'lucide-react';
import { companyInfo } from '../data/companyInfo';

/**
 * Mobile-only fixed bottom CTA — Call, WhatsApp, Quote.
 * Critical for lead conversion on mobile (where 70%+ of traffic comes from).
 * "Free Quote" routes to the dedicated /get-a-quote landing page (the Google
 * Ads destination) so paid traffic and organic traffic land in the same
 * high-converting funnel.
 */
export default function MobileStickyCTA() {
  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-black/95 backdrop-blur-lg border-t border-gold-500/30 px-2 py-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] grid grid-cols-3 gap-2"
      data-testid="mobile-sticky-cta"
      role="navigation"
      aria-label="Quick actions"
    >
      <a
        href={companyInfo.mobileHref}
        className="flex flex-col items-center justify-center gap-0.5 py-2 min-h-[52px] rounded-md bg-green-600 text-white font-bold text-xs"
        aria-label="Call HomeGo Removals"
        data-testid="sticky-call-btn"
      >
        <Phone className="w-4 h-4" aria-hidden="true" />
        <span>Call</span>
      </a>
      <a
        href={companyInfo.social.whatsapp}
        rel="noopener noreferrer"
        className="flex flex-col items-center justify-center gap-0.5 py-2 min-h-[52px] rounded-md bg-emerald-500 text-white font-bold text-xs"
        aria-label="Open WhatsApp chat with HomeGo Removals"
        data-testid="sticky-whatsapp-btn"
      >
        <MessageCircle className="w-4 h-4" aria-hidden="true" />
        <span>WhatsApp</span>
      </a>
      <Link
        to="/get-a-quote"
        className="flex flex-col items-center justify-center gap-0.5 py-2 min-h-[52px] rounded-md bg-gradient-to-r from-gold-500 to-gold-400 text-black font-bold text-xs"
        aria-label="Open free quote page"
        data-testid="sticky-quote-btn"
      >
        <span className="text-base leading-none" aria-hidden="true">£</span>
        <span>Free Quote</span>
      </Link>
    </div>
  );
}
